import React from 'react'
import { Route } from 'react-router-dom'

import {Helmet} from "react-helmet";

import PageAnalytics from '../../components/PageAnalytics'

// SECTIONS
import FaqSection from './FaqSection'

const Page = (props) => {
  console.log("propssss", props)
  return (
    <div>

      {/* Html header */}
      <Helmet>
        <title>Faq:</title>
      </Helmet>

      {/* Analytics */}
      <PageAnalytics title='Faq:'/>

      <Route path='/faq/:slug' component={FaqSection} />
    </div>
  )
}


export default Page




// WEBPACK FOOTER //
// ./src/pages/Faq/index.js